module.exports = __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_de_135x40.63279d3d.svg";